export default class Landman {
    billingOffice: string;
    employeeType: string;
    billRate: number;
    payRate: number;
    email: string;
    taxType: string;
    lastName: string;
    firstName: string;
    ssn: string;
    taxId: string;
    middleName: string;
    corpName: string;
    payUnit: string;
    billUnit: string;
    managerName: string;
    managerTsdNo: number;
}


// WEBPACK FOOTER //
// ./src/models/personnel/Landman.ts